import styled, { css } from 'styled-components'

import { themeColor, themeSpace } from '../theme'
import { Space } from '../Space'
import { Image } from '../Image'

export const StickyWrapper = styled.div<{
  backgroundColor?: string
  textColor: string
  anchor: boolean
  horizontalAlignment: 'left' | 'right'
  verticalAlignment: 'top' | 'bottom'
}>`
  align-items: center;

  z-index: 100;
  ${({ anchor, verticalAlignment }) =>
    anchor
      ? css`
          position: absolute;
          ${() =>
            verticalAlignment === 'bottom' &&
            css`
              transform: translateY(-100%);
              top: 0px;
            `}
        `
      : css`
          position: fixed;
          bottom: 0px;
        `}
  ${({ horizontalAlignment, verticalAlignment }) =>
    horizontalAlignment === 'left' && verticalAlignment === 'top'
      ? css`
          left: 0px;
          border-bottom-right-radius: 0.5em;
        `
      : horizontalAlignment === 'left' && verticalAlignment === 'bottom'
        ? css`
            left: 0px;
            border-top-right-radius: 0.5em;
          `
        : horizontalAlignment === 'right' && verticalAlignment === 'top'
          ? css`
              right: 0px;
              border-bottom-left-radius: 0.5em;
            `
          : css`
              right: 0px;
              border-top-left-radius: 0.5em;
            `}
  min-height: 55px;
  height: auto;
  width: 180px;
  padding: ${themeSpace(1)} ${themeSpace(2)};

  color: ${p => (p.textColor === 'Light' ? themeColor('white')(p) : themeColor('darkGray')(p))};
  background-color: ${({ backgroundColor }) => backgroundColor ?? 'black'};

  .rich-text-content {
    p {
      color: ${p => (p.textColor === 'Light' ? themeColor('white')(p) : themeColor('darkGray')(p))};
    }

    p:last-of-type {
      margin-bottom: 0;
    }
  }
`

export const ContactUsLink = styled.a`
  padding-left: ${themeSpace(1)};
`

export const TitleWrapper = styled(Space)`
  cursor: pointer;
`

export const ScaledImage = styled(Image)`
  object-fit: contain;
  height: 1.5em;
`
